webpackJsonp([114276838955818,60335399758886],{

/***/ 119:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"FlashTeam games"}},"logoImg":{"childImageSharp":{"sizes":{"tracedSVG":"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='400' height='111' viewBox='0 0 400 111' version='1'%3e%3cpath d='M39 20C20 31 18 36 22 62c4 22 5 24 9 24 6 0 8-3 7-8l-2-10c0-8 0-9 6-9 4 0 9-5 9-9 0-5-4-6-10-4-7 2-7 2-7-1 0-2 2-3 9-7 11-5 12-7 12-13 0-10-6-12-16-5m181 2c-10 2-14 6-13 14 1 5 3 6 9 4l6-1c2 2 0 28-3 33-2 4-1 11 1 12 3 3 8 2 11 0 3-4 9-28 9-40 0-4 2-5 8-3 6 3 8 2 11-4 4-7 4-10 1-12-5-3-29-5-40-3M60 25c-4 4-4 9-4 29 1 20 2 22 6 25 4 2 12 0 18-4 8-6 7-17-1-16h-6l-3 1-2-18c-2-22-3-23-8-17m40 1c-7 5-11 20-11 38 0 14 0 15 4 15 3 0 5-2 6-7s6-8 9-8c3 1 4 1 7 9 2 3 6 4 8 1 4-4 0-28-6-41-5-10-11-13-17-7m43 1c-11 5-16 13-14 22 1 5 4 7 11 7 11 2 12 2 12 4-1 1-2 2-11 2-11 0-13 1-13 7 0 5 3 7 11 7 17 0 24-5 27-19 1-8-3-12-16-15-11-3-7-6 5-4 7 2 12-7 7-12-3-3-11-3-19 1m53 3l-3 8c-2 8-3 10-7 10h-3l-1-8c-1-9-1-10-5-10-5 0-6 1-9 23-3 24-3 27 0 28 4 2 10-3 10-8 0-3 4-7 6-7 4 0 5 2 5 8 0 5 1 7 5 7 2 0 3-1 4-3 4-9 7-45 5-48-1-3-5-3-7 0m-94 10c-4 2-2 14 3 14 3 0 6-5 6-9 0-6-4-9-9-5m163 2c-10 3-20 17-21 31 0 9 1 12 8 15 11 6 25 1 25-8 0-3-1-3-8-4-10-1-12-6-3-6 7 0 14-3 15-7s-2-5-11-5c-6 0-7-1-7-2s2-2 7-3c9-1 12-3 12-7l-1-5c-2-1-11-1-16 1m96 0c-2 0-3 1-3 2l-6 4v-2c1-6-5-7-11-1s-12 7-12 3c0-3-8 0-8 4-2 5-1 37 0 40 2 3 8 4 11 1 2-4 3-6 0-16-1-7-1-7 1-10l4-4c2 0 4 6 4 15 0 7 3 16 5 17s3 1 6-1c5-2 6-5 3-15-4-12-4-18 1-18 2 0 4 4 4 15 1 8 3 15 6 16 3 2 8-1 10-5 1-3 1-4-2-10-4-12-4-14-3-24l-1-11c-3-2-6-2-9 0m-66 2c-8 6-15 27-15 44v6h3c4 0 4 0 7-5 5-10 13-11 15-2 1 6 3 8 6 8 4-1 5-4 4-20 0-15-3-27-7-32-3-3-9-3-13 1m1 14c-2 2-3 8-1 11 2 4 9 0 10-6s-5-10-9-5' fill='lightgray' fill-rule='evenodd'/%3e%3c/svg%3e","aspectRatio":3.6186440677966103,"src":"/static/logo-a0de86001c0e343d7c9e8eb5181f5604-4055d.png","srcSet":"/static/logo-a0de86001c0e343d7c9e8eb5181f5604-d48a9.png 107w,\n/static/logo-a0de86001c0e343d7c9e8eb5181f5604-19c57.png 214w,\n/static/logo-a0de86001c0e343d7c9e8eb5181f5604-4055d.png 427w","sizes":"(max-width: 427px) 100vw, 427px"}}}},"layoutContext":{}}

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(225);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(119);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return Glamor.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(110);
	var isArguments = __webpack_require__(109);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 109:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 110:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(26);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(45);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(44);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(84);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(83);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(1));
	var glamor = __webpack_require__(24);
	
	var htmlTagNames = [
	  "a",
	  "abbr",
	  "acronym",
	  "address",
	  "applet",
	  "area",
	  "article",
	  "aside",
	  "audio",
	  "b",
	  "base",
	  "basefont",
	  "bdi",
	  "bdo",
	  "bgsound",
	  "big",
	  "blink",
	  "blockquote",
	  "body",
	  "br",
	  "button",
	  "canvas",
	  "caption",
	  "center",
	  "cite",
	  "code",
	  "col",
	  "colgroup",
	  "command",
	  "content",
	  "data",
	  "datalist",
	  "dd",
	  "del",
	  "details",
	  "dfn",
	  "dialog",
	  "dir",
	  "div",
	  "dl",
	  "dt",
	  "element",
	  "em",
	  "embed",
	  "fieldset",
	  "figcaption",
	  "figure",
	  "font",
	  "footer",
	  "form",
	  "frame",
	  "frameset",
	  "h1",
	  "h2",
	  "h3",
	  "h4",
	  "h5",
	  "h6",
	  "head",
	  "header",
	  "hgroup",
	  "hr",
	  "html",
	  "i",
	  "iframe",
	  "image",
	  "img",
	  "input",
	  "ins",
	  "isindex",
	  "kbd",
	  "keygen",
	  "label",
	  "legend",
	  "li",
	  "link",
	  "listing",
	  "main",
	  "map",
	  "mark",
	  "marquee",
	  "math",
	  "menu",
	  "menuitem",
	  "meta",
	  "meter",
	  "multicol",
	  "nav",
	  "nextid",
	  "nobr",
	  "noembed",
	  "noframes",
	  "noscript",
	  "object",
	  "ol",
	  "optgroup",
	  "option",
	  "output",
	  "p",
	  "param",
	  "picture",
	  "plaintext",
	  "pre",
	  "progress",
	  "q",
	  "rb",
	  "rbc",
	  "rp",
	  "rt",
	  "rtc",
	  "ruby",
	  "s",
	  "samp",
	  "script",
	  "section",
	  "select",
	  "shadow",
	  "slot",
	  "small",
	  "source",
	  "spacer",
	  "span",
	  "strike",
	  "strong",
	  "style",
	  "sub",
	  "summary",
	  "sup",
	  "svg",
	  "table",
	  "tbody",
	  "td",
	  "template",
	  "textarea",
	  "tfoot",
	  "th",
	  "thead",
	  "time",
	  "title",
	  "tr",
	  "track",
	  "tt",
	  "u",
	  "ul",
	  "var",
	  "video",
	  "wbr",
	  "xmp"
	]
	;
	
	var svgTagNames = [
	  "a",
	  "altGlyph",
	  "altGlyphDef",
	  "altGlyphItem",
	  "animate",
	  "animateColor",
	  "animateMotion",
	  "animateTransform",
	  "animation",
	  "audio",
	  "canvas",
	  "circle",
	  "clipPath",
	  "color-profile",
	  "cursor",
	  "defs",
	  "desc",
	  "discard",
	  "ellipse",
	  "feBlend",
	  "feColorMatrix",
	  "feComponentTransfer",
	  "feComposite",
	  "feConvolveMatrix",
	  "feDiffuseLighting",
	  "feDisplacementMap",
	  "feDistantLight",
	  "feDropShadow",
	  "feFlood",
	  "feFuncA",
	  "feFuncB",
	  "feFuncG",
	  "feFuncR",
	  "feGaussianBlur",
	  "feImage",
	  "feMerge",
	  "feMergeNode",
	  "feMorphology",
	  "feOffset",
	  "fePointLight",
	  "feSpecularLighting",
	  "feSpotLight",
	  "feTile",
	  "feTurbulence",
	  "filter",
	  "font",
	  "font-face",
	  "font-face-format",
	  "font-face-name",
	  "font-face-src",
	  "font-face-uri",
	  "foreignObject",
	  "g",
	  "glyph",
	  "glyphRef",
	  "handler",
	  "hatch",
	  "hatchpath",
	  "hkern",
	  "iframe",
	  "image",
	  "line",
	  "linearGradient",
	  "listener",
	  "marker",
	  "mask",
	  "mesh",
	  "meshgradient",
	  "meshpatch",
	  "meshrow",
	  "metadata",
	  "missing-glyph",
	  "mpath",
	  "path",
	  "pattern",
	  "polygon",
	  "polyline",
	  "prefetch",
	  "radialGradient",
	  "rect",
	  "script",
	  "set",
	  "solidColor",
	  "solidcolor",
	  "stop",
	  "style",
	  "svg",
	  "switch",
	  "symbol",
	  "tbreak",
	  "text",
	  "textArea",
	  "textPath",
	  "title",
	  "tref",
	  "tspan",
	  "unknown",
	  "use",
	  "video",
	  "view",
	  "vkern"
	]
	;
	
	var domElements = htmlTagNames.concat(svgTagNames).filter(function (tag, index, array) {
	  return array.indexOf(tag) === index;
	});
	
	var CHANNEL = '__glamorous__'; /* istanbul ignore next */
	
	var isPreact = false;
	
	var _PropTypes = void 0;
	
	/* istanbul ignore next */
	if (isPreact) {
	  if (!React.PropTypes) {
	    _PropTypes = function PropTypes() {
	      return _PropTypes;
	    };
	
	    ['array', 'bool', 'func', 'number', 'object', 'string', 'symbol', 'any', 'arrayOf', 'element', 'instanceOf', 'node', 'objectOf', 'oneOf', 'oneOfType', 'shape', 'exact'].forEach(function (type) {
	      _PropTypes[type] = _PropTypes;
	    });
	  }
	  // copied from preact-compat
	  /* eslint-disable no-eq-null, eqeqeq, consistent-return */
	  if (!React.Children) {
	    var Children = {
	      map: function map(children, fn, ctx) {
	        if (children == null) {
	          return null;
	        }
	        children = Children.toArray(children);
	        if (ctx && ctx !== children) {
	          fn = fn.bind(ctx);
	        }
	        return children.map(fn);
	      },
	      forEach: function forEach(children, fn, ctx) {
	        if (children == null) {
	          return null;
	        }
	        children = Children.toArray(children);
	        if (ctx && ctx !== children) {
	          fn = fn.bind(ctx);
	        }
	        children.forEach(fn);
	      },
	      count: function count(children) {
	        return children && children.length || 0;
	      },
	      only: function only(children) {
	        children = Children.toArray(children);
	        if (children.length !== 1) {
	          throw new Error('Children.only() expects only one child.');
	        }
	        return children[0];
	      },
	      toArray: function toArray(children) {
	        if (children == null) {
	          return [];
	        }
	        return [].concat(children);
	      }
	    };
	    React.Children = Children;
	  }
	  /* eslint-enable no-eq-null, eqeqeq, consistent-return */
	} else if (parseFloat(React.version.slice(0, 4)) >= 15.5) {
	  /* istanbul ignore next */
	  try {
	    _PropTypes = __webpack_require__(7);
	    /* istanbul ignore next */
	  } catch (error) {
	    // ignore
	  }
	}
	/* istanbul ignore next */
	_PropTypes = _PropTypes || React.PropTypes;
	
	/*
	eslint
	  import/no-mutable-exports:0,
	  import/prefer-default-export:0,
	  react/no-deprecated:0
	 */
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	function generateWarningMessage(Comp) {
	  var componentName = Comp.displayName || Comp.name || 'FunctionComponent';
	  // eslint-disable-next-line max-len
	  return 'glamorous warning: Expected component called "' + componentName + '" which uses withTheme to be within a ThemeProvider but none was found.';
	}
	
	function withTheme(ComponentToTheme) {
	  var _defaultContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$noWarn = _ref.noWarn,
	      noWarn = _ref$noWarn === undefined ? false : _ref$noWarn,
	      _ref$createElement = _ref.createElement,
	      createElement = _ref$createElement === undefined ? true : _ref$createElement;
	
	  var ThemedComponent = function (_React$Component) {
	    inherits(ThemedComponent, _React$Component);
	
	    function ThemedComponent() {
	      var _temp, _this, _ret;
	
	      classCallCheck(this, ThemedComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.warned = noWarn, _this.state = { theme: {} }, _this.setTheme = function (theme) {
	        return _this.setState({ theme: theme });
	      }, _temp), possibleConstructorReturn(_this, _ret);
	    }
	
	    // eslint-disable-next-line complexity
	    ThemedComponent.prototype.componentWillMount = function componentWillMount() {
	      if (!this.context[CHANNEL]) {
	        if (false) {
	          this.warned = true;
	          // eslint-disable-next-line no-console
	          console.warn(generateWarningMessage(ComponentToTheme));
	        }
	      }
	      var theme = this.props.theme;
	
	      if (this.context[CHANNEL]) {
	        // if a theme is provided via props,
	        // it takes precedence over context
	        this.setTheme(theme ? theme : this.context[CHANNEL].getState());
	      } else {
	        this.setTheme(theme || {});
	      }
	    };
	
	    ThemedComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.theme !== nextProps.theme) {
	        this.setTheme(nextProps.theme);
	      }
	    };
	
	    ThemedComponent.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[CHANNEL] && !this.props.theme) {
	        // subscribe to future theme changes
	        this.subscriptionId = this.context[CHANNEL].subscribe(this.setTheme);
	      }
	    };
	
	    ThemedComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	      // cleanup subscription
	      this.subscriptionId && this.context[CHANNEL].unsubscribe(this.subscriptionId);
	    };
	
	    ThemedComponent.prototype.render = function render() {
	      if (createElement) {
	        return React.createElement(ComponentToTheme, _extends({}, this.props, this.state));
	      } else {
	        // this allows us to effectively use the GlamorousComponent
	        // as our `render` method without going through lifecycle hooks.
	        // Also allows us to forward the context in the scenario where
	        // a user wants to add more context.
	        // eslint-disable-next-line babel/new-cap
	        return ComponentToTheme.call(this, _extends({}, this.props, this.state), this.context);
	      }
	    };
	
	    return ThemedComponent;
	  }(React.Component);
	
	   false ? ThemedComponent.propTypes = {
	    theme: _PropTypes.object
	  } : void 0;
	
	
	  var defaultContextTypes = (_defaultContextTypes = {}, _defaultContextTypes[CHANNEL] = _PropTypes.object, _defaultContextTypes);
	
	  var userDefinedContextTypes = null;
	
	  // configure the contextTypes to be settable by the user,
	  // however also retaining the glamorous channel.
	  Object.defineProperty(ThemedComponent, 'contextTypes', {
	    enumerable: true,
	    configurable: true,
	    set: function set$$1(value) {
	      userDefinedContextTypes = value;
	    },
	    get: function get$$1() {
	      // if the user has provided a contextTypes definition,
	      // merge the default context types with the provided ones.
	      if (userDefinedContextTypes) {
	        return _extends({}, defaultContextTypes, userDefinedContextTypes);
	      }
	      return defaultContextTypes;
	    }
	  });
	
	  return ThemedComponent;
	}
	
	var isFunction_1 = isFunction;
	
	var toString = Object.prototype.toString;
	
	function isFunction (fn) {
	  var string = toString.call(fn);
	  return string === '[object Function]' ||
	    (typeof fn === 'function' && string !== '[object RegExp]') ||
	    (typeof window !== 'undefined' &&
	     // IE8 and below
	     (fn === window.setTimeout ||
	      fn === window.alert ||
	      fn === window.confirm ||
	      fn === window.prompt))
	}
	
	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	var isobject = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};
	
	function isObjectObject(o) {
	  return isobject(o) === true
	    && Object.prototype.toString.call(o) === '[object Object]';
	}
	
	var isPlainObject = function isPlainObject(o) {
	  var ctor,prot;
	
	  if (isObjectObject(o) === false) return false;
	
	  // If has modified constructor
	  ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;
	
	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;
	
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	
	  // Most likely a plain Object
	  return true;
	};
	
	function createBroadcast (initialState) {
	  var listeners = {};
	  var id = 1;
	  var _state = initialState;
	
	  function getState () {
	    return _state
	  }
	
	  function setState (state) {
	    _state = state;
	    var keys = Object.keys(listeners);
	    var i = 0;
	    var len = keys.length;
	    for (; i < len; i++) {
	      // if a listener gets unsubscribed during setState we just skip it
	      if (listeners[keys[i]]) { listeners[keys[i]](state); }
	    }
	  }
	
	  // subscribe to changes and return the subscriptionId
	  function subscribe (listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('listener must be a function.')
	    }
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    return currentId
	  }
	
	  // remove subscription by removing the listener function
	  function unsubscribe (id) {
	    listeners[id] = undefined;
	  }
	
	  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
	}
	
	var _ThemeProvider$childC, _ThemeProvider$contex;
	
	/**
	 * This is a component which will provide a theme to the entire tree
	 * via context and event listener
	 * (because pure components block context updates)
	 * inspired by the styled-components implementation
	 * https://github.com/styled-components/styled-components
	 * @param {Object} theme the theme object..
	 */
	
	var ThemeProvider = function (_React$Component) {
	  inherits(ThemeProvider, _React$Component);
	
	  function ThemeProvider() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, ThemeProvider);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setOuterTheme = function (theme) {
	      _this.outerTheme = theme;
	      if (_this.broadcast !== undefined) {
	        _this.publishTheme();
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  // create theme, by merging with outer theme, if present
	  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
	    var theme = passedTheme || this.props.theme;
	    if (isFunction_1(theme)) {
	      var mergedTheme = theme(this.outerTheme);
	      if (!isPlainObject(mergedTheme)) {
	        throw new Error('[ThemeProvider] Please return an object from your theme function, ' + 'i.e. theme={() => ({})}!');
	      }
	      return mergedTheme;
	    }
	    return _extends({}, this.outerTheme, theme);
	  };
	
	  ThemeProvider.prototype.getChildContext = function getChildContext() {
	    var _ref;
	
	    return _ref = {}, _ref[CHANNEL] = this.broadcast, _ref;
	  };
	
	  ThemeProvider.prototype.publishTheme = function publishTheme(theme) {
	    this.broadcast.setState(this.getTheme(theme));
	  };
	
	  ThemeProvider.prototype.componentDidMount = function componentDidMount() {
	    // create a new subscription for keeping track of outer theme, if present
	    if (this.context[CHANNEL]) {
	      this.subscriptionId = this.context[CHANNEL].subscribe(this.setOuterTheme);
	    }
	  };
	
	  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
	    // set broadcast state by merging outer theme with own
	    if (this.context[CHANNEL]) {
	      this.setOuterTheme(this.context[CHANNEL].getState());
	    }
	    this.broadcast = createBroadcast(this.getTheme(this.props.theme));
	  };
	
	  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.theme !== nextProps.theme) {
	      this.publishTheme(nextProps.theme);
	    }
	  };
	
	  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.subscriptionId && this.context[CHANNEL].unsubscribe(this.subscriptionId);
	  };
	
	  ThemeProvider.prototype.render = function render() {
	    return this.props.children ? React.Children.only(this.props.children) : null;
	  };
	
	  return ThemeProvider;
	}(React.Component);
	
	ThemeProvider.childContextTypes = (_ThemeProvider$childC = {}, _ThemeProvider$childC[CHANNEL] = _PropTypes.object.isRequired, _ThemeProvider$childC);
	
	ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL] = _PropTypes.object, _ThemeProvider$contex);
	
	 false ? ThemeProvider.propTypes = {
	  theme: _PropTypes.oneOfType([_PropTypes.object, _PropTypes.func]).isRequired,
	  children: _PropTypes.node
	} : void 0;
	
	/**
	 * This function takes a className string and gets all the
	 * associated glamor styles. It's used to merge glamor styles
	 * from a className to make sure that specificity is not
	 * a problem when passing a className to a component.
	 * @param {String} [className=''] the className string
	 * @return {Object} { glamorStyles, glamorlessClassName }
	 *   - glamorStyles is an array of all the glamor styles objects
	 *   - glamorlessClassName is the rest of the className string
	 *     without the glamor classNames
	 */
	function extractGlamorStyles(className) {
	  var glamorlessClassName = [];
	  var glamorStyles = [];
	  className.toString().split(' ').forEach(function (name) {
	    if (glamor.styleSheet.registered[name.substring(4)] === undefined) {
	      glamorlessClassName.push(name);
	    } else {
	      var style = buildGlamorSrcFromClassName(name);
	      glamorStyles.push(style);
	    }
	  });
	
	  return { glamorlessClassName: glamorlessClassName, glamorStyles: glamorStyles };
	}
	
	/** Glamor's css function returns an object with the shape
	 *
	 * {
	 *   [`data-css-${hash}`]: '',
	 *   toString() { return `css-${hash}` }
	 * }
	 *
	 * Whenever glamor's build function encounters an object with
	 * this shape it just pulls the resulting styles from the cache.
	 *
	 * note: the toString method is not needed to qualify the shape
	 **/
	function buildGlamorSrcFromClassName(className) {
	  var _ref;
	
	  return _ref = {}, _ref['data-' + className] = '', _ref;
	}
	
	function getGlamorClassName(_ref2) {
	  var styles = _ref2.styles,
	      props = _ref2.props,
	      cssOverrides = _ref2.cssOverrides,
	      cssProp = _ref2.cssProp,
	      context = _ref2.context,
	      displayName = _ref2.displayName;
	
	  var _handleStyles = handleStyles([].concat(styles, [props.className, cssOverrides, cssProp]), props, context),
	      mappedArgs = _handleStyles.mappedArgs,
	      nonGlamorClassNames = _handleStyles.nonGlamorClassNames;
	  // eslint-disable-next-line max-len
	
	
	  var isDev = ("production") === 'development' || !("production");
	  var devRules = isDev ? { label: displayName } : null;
	  var glamorClassName = glamor.css.apply(undefined, [devRules].concat(mappedArgs)).toString();
	  var extras = nonGlamorClassNames.join(' ').trim();
	  return (glamorClassName + ' ' + extras).trim();
	}
	
	// this next function is on a "hot" code-path
	// so it's pretty complex to make sure it's fast.
	// eslint-disable-next-line complexity
	function handleStyles(styles, props, context) {
	  var current = void 0;
	  var mappedArgs = [];
	  var nonGlamorClassNames = [];
	  for (var i = 0; i < styles.length; i++) {
	    current = styles[i];
	    while (typeof current === 'function') {
	      current = current(props, context);
	    }
	    if (typeof current === 'string') {
	      var _extractGlamorStyles = extractGlamorStyles(current),
	          glamorStyles = _extractGlamorStyles.glamorStyles,
	          glamorlessClassName = _extractGlamorStyles.glamorlessClassName;
	
	      mappedArgs.push.apply(mappedArgs, glamorStyles);
	      nonGlamorClassNames.push.apply(nonGlamorClassNames, glamorlessClassName);
	    } else if (Array.isArray(current)) {
	      var recursed = handleStyles(current, props, context);
	      mappedArgs.push.apply(mappedArgs, recursed.mappedArgs);
	      nonGlamorClassNames.push.apply(nonGlamorClassNames, recursed.nonGlamorClassNames);
	    } else {
	      mappedArgs.push(current);
	    }
	  }
	  return { mappedArgs: mappedArgs, nonGlamorClassNames: nonGlamorClassNames };
	}
	
	/*
	 * This is a relatively small abstraction that's ripe for open sourcing.
	 * Documentation is in the README.md
	 */
	
	function createGlamorous(splitProps) {
	  return glamorous;
	
	  /**
	   * This is the main export and the function that people
	   * interact with most directly.
	   *
	   * It accepts a component which can be a string or
	   * a React Component and returns
	   * a "glamorousComponentFactory"
	   * @param {String|ReactComponent} comp the component to render
	   * @param {Object} options helpful info for the GlamorousComponents
	   * @return {Function} the glamorousComponentFactory
	   */
	  function glamorous(comp) {
	    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var rootEl = config.rootEl,
	        displayName = config.displayName,
	        shouldClassNameUpdate = config.shouldClassNameUpdate,
	        _config$filterProps = config.filterProps,
	        filterProps = _config$filterProps === undefined ? [] : _config$filterProps,
	        _config$forwardProps = config.forwardProps,
	        forwardProps = _config$forwardProps === undefined ? [] : _config$forwardProps,
	        _config$propsAreCssOv = config.propsAreCssOverrides,
	        propsAreCssOverrides = _config$propsAreCssOv === undefined ? comp.propsAreCssOverrides : _config$propsAreCssOv,
	        basePropsToApply = config.withProps;
	
	    Object.assign(glamorousComponentFactory, { withConfig: withConfig });
	    return glamorousComponentFactory;
	
	    function withConfig(newConfig) {
	      return glamorous(comp, _extends({}, config, newConfig));
	    }
	
	    /**
	     * This returns a React Component that renders the comp (closure)
	     * with a className based on the given glamor styles object(s)
	     * @param {...Object|Function} styles the styles to create with glamor.
	     *   If any of these are functions, they are invoked with the component
	     *   props and the return value is used.
	     * @return {ReactComponent} the ReactComponent function
	     */
	    function glamorousComponentFactory() {
	      for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
	        styles[_key] = arguments[_key];
	      }
	
	      /**
	       * This is a component which will render the comp (closure)
	       * with the glamorous styles (closure). Forwards any valid
	       * props to the underlying component.
	       */
	      var GlamorousComponent = withTheme(function (props, context) {
	        props = getPropsToApply(GlamorousComponent.propsToApply, {}, props, context);
	        var updateClassName = shouldUpdate(props, context, this.previous);
	
	        if (shouldClassNameUpdate) {
	          this.previous = { props: props, context: context };
	        }
	
	        var _splitProps = splitProps(props, GlamorousComponent),
	            toForward = _splitProps.toForward,
	            cssOverrides = _splitProps.cssOverrides,
	            cssProp = _splitProps.cssProp;
	
	        // create className to apply
	
	
	        this.className = updateClassName ? getGlamorClassName({
	          styles: GlamorousComponent.styles,
	          props: props,
	          cssOverrides: cssOverrides,
	          cssProp: cssProp,
	          context: context,
	          displayName: GlamorousComponent.displayName
	        }) : this.className;
	
	        return React.createElement(GlamorousComponent.comp, _extends({
	          // if innerRef is forwarded we don't want to apply it here
	          ref: 'innerRef' in toForward ? undefined : props.innerRef
	        }, toForward, {
	          className: this.className
	        }));
	      }, { noWarn: true, createElement: false });
	
	       false ? GlamorousComponent.propTypes = {
	        // className accepts an object due to glamor's css function
	        // returning an object with a toString method that gives the className
	        className: _PropTypes.oneOfType([_PropTypes.string, _PropTypes.object]),
	        cssOverrides: _PropTypes.object,
	        innerRef: _PropTypes.oneOfType([_PropTypes.func, _PropTypes.object]),
	        glam: _PropTypes.object
	      } : void 0;
	
	      function shouldUpdate(props, context, previous) {
	        // exiting early so components which do not use this
	        // optimization are not penalized by hanging onto
	        // references to previous props and context
	        if (!shouldClassNameUpdate) {
	          return true;
	        }
	        var update = true;
	        if (previous) {
	          if (!shouldClassNameUpdate(previous.props, props, previous.context, context)) {
	            update = false;
	          }
	        }
	
	        return update;
	      }
	
	      Object.assign(GlamorousComponent, getGlamorousComponentMetadata({
	        comp: comp,
	        styles: styles,
	        rootEl: rootEl,
	        filterProps: filterProps,
	        forwardProps: forwardProps,
	        displayName: displayName,
	        propsToApply: basePropsToApply
	      }), {
	        isGlamorousComponent: true,
	        propsAreCssOverrides: propsAreCssOverrides,
	        withComponent: function (newComp) {
	          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	          var fwp = GlamorousComponent.forwardProps,
	              flp = GlamorousComponent.filterProps,
	              componentProperties = objectWithoutProperties(GlamorousComponent, ['forwardProps', 'filterProps']);
	
	          return glamorous(_extends({}, componentProperties, {
	            comp: newComp,
	            rootEl: getRootEl(newComp)
	          }), _extends({
	            // allows the forwardProps and filterProps to be overridden
	            forwardProps: fwp,
	            filterProps: flp
	          }, options))();
	        },
	        withProps: function () {
	          for (var _len2 = arguments.length, propsToApply = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            propsToApply[_key2] = arguments[_key2];
	          }
	
	          return glamorous(GlamorousComponent, { withProps: propsToApply })();
	        },
	        withConfig: withConfig
	      });
	      return GlamorousComponent;
	    }
	  }
	
	  function getGlamorousComponentMetadata(_ref) {
	    var comp = _ref.comp,
	        styles = _ref.styles,
	        rootEl = _ref.rootEl,
	        filterProps = _ref.filterProps,
	        forwardProps = _ref.forwardProps,
	        displayName = _ref.displayName,
	        basePropsToApply = _ref.propsToApply;
	
	    var componentsComp = comp.comp ? comp.comp : comp;
	    var propsToApply = comp.propsToApply ? [].concat(comp.propsToApply, arrayify(basePropsToApply)) : arrayify(basePropsToApply);
	    return {
	      // join styles together (for anyone doing: glamorous(glamorous.a({}), {}))
	      styles: when(comp.styles, styles),
	      // keep track of the ultimate rootEl to render (we never
	      // actually render anything but
	      // the base component, even when people wrap a glamorous
	      // component in glamorous
	      comp: componentsComp,
	      rootEl: rootEl || getRootEl(comp),
	      // join forwardProps and filterProps
	      // (for anyone doing: glamorous(glamorous.a({}), {}))
	      forwardProps: when(comp.forwardProps, forwardProps),
	      filterProps: when(comp.filterProps, filterProps),
	      // set the displayName to something that's slightly more
	      // helpful than `GlamorousComponent` :)
	      displayName: displayName || 'glamorous(' + getDisplayName(comp) + ')',
	      // these are props that should be applied to the component at render time
	      propsToApply: propsToApply
	    };
	  }
	}
	
	/**
	 * reduces the propsToApply given to a single props object
	 * @param {Array} propsToApply an array of propsToApply objects:
	 *   - object
	 *   - array of propsToApply items
	 *   - function that accepts the accumulated props and the context
	 * @param {Object} accumulator an object to apply props onto
	 * @param {Object} props the props that should ultimately take precedence
	 * @param {*} context the context object
	 * @return {Object} the reduced props
	 */
	function getPropsToApply(propsToApply, accumulator, props, context) {
	  // using forEach rather than reduce here because the reduce solution
	  // effectively did the same thing because we manipulate the `accumulator`
	  propsToApply.forEach(function (propsToApplyItem) {
	    if (typeof propsToApplyItem === 'function') {
	      return Object.assign(accumulator, propsToApplyItem(Object.assign({}, accumulator, props), context));
	    } else if (Array.isArray(propsToApplyItem)) {
	      return Object.assign(accumulator, getPropsToApply(propsToApplyItem, accumulator, props, context));
	    }
	    return Object.assign(accumulator, propsToApplyItem);
	  });
	  // props wins
	  return Object.assign(accumulator, props);
	}
	
	function arrayify() {
	  var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return Array.isArray(x) ? x : [x];
	}
	
	function when(comp, prop) {
	  return comp ? comp.concat(prop) : prop;
	}
	
	function getRootEl(comp) {
	  return comp.rootEl ? comp.rootEl : comp.comp || comp;
	}
	
	function getDisplayName(comp) {
	  return typeof comp === 'string' ? comp : comp.displayName || comp.name || 'unknown';
	}
	
	//
	// Main
	//
	
	function memoize (fn, options) {
	  var cache = options && options.cache
	    ? options.cache
	    : cacheDefault;
	
	  var serializer = options && options.serializer
	    ? options.serializer
	    : serializerDefault;
	
	  var strategy = options && options.strategy
	    ? options.strategy
	    : strategyDefault;
	
	  return strategy(fn, {
	    cache: cache,
	    serializer: serializer
	  })
	}
	
	//
	// Strategy
	//
	
	function isPrimitive (value) {
	  return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
	}
	
	function monadic (fn, cache, serializer, arg) {
	  var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
	
	  var computedValue = cache.get(cacheKey);
	  if (typeof computedValue === 'undefined') {
	    computedValue = fn.call(this, arg);
	    cache.set(cacheKey, computedValue);
	  }
	
	  return computedValue
	}
	
	function variadic (fn, cache, serializer) {
	  var args = Array.prototype.slice.call(arguments, 3);
	  var cacheKey = serializer(args);
	
	  var computedValue = cache.get(cacheKey);
	  if (typeof computedValue === 'undefined') {
	    computedValue = fn.apply(this, args);
	    cache.set(cacheKey, computedValue);
	  }
	
	  return computedValue
	}
	
	function assemble (fn, context, strategy, cache, serialize) {
	  return strategy.bind(
	    context,
	    fn,
	    cache,
	    serialize
	  )
	}
	
	function strategyDefault (fn, options) {
	  var strategy = fn.length === 1 ? monadic : variadic;
	
	  return assemble(
	    fn,
	    this,
	    strategy,
	    options.cache.create(),
	    options.serializer
	  )
	}
	
	function strategyVariadic (fn, options) {
	  var strategy = variadic;
	
	  return assemble(
	    fn,
	    this,
	    strategy,
	    options.cache.create(),
	    options.serializer
	  )
	}
	
	function strategyMonadic (fn, options) {
	  var strategy = monadic;
	
	  return assemble(
	    fn,
	    this,
	    strategy,
	    options.cache.create(),
	    options.serializer
	  )
	}
	
	//
	// Serializer
	//
	
	function serializerDefault () {
	  return JSON.stringify(arguments)
	}
	
	//
	// Cache
	//
	
	function ObjectWithoutPrototypeCache () {
	  this.cache = Object.create(null);
	}
	
	ObjectWithoutPrototypeCache.prototype.has = function (key) {
	  return (key in this.cache)
	};
	
	ObjectWithoutPrototypeCache.prototype.get = function (key) {
	  return this.cache[key]
	};
	
	ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
	  this.cache[key] = value;
	};
	
	var cacheDefault = {
	  create: function create () {
	    return new ObjectWithoutPrototypeCache()
	  }
	};
	
	//
	// API
	//
	
	var src = memoize;
	var strategies = {
	  variadic: strategyVariadic,
	  monadic: strategyMonadic
	};
	src.strategies = strategies;
	
	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var a = ["coords","download","href","name","rel","shape","target","type"];
	var abbr = ["title"];
	var applet = ["alt","height","name","width"];
	var area = ["alt","coords","download","href","rel","shape","target","type"];
	var audio = ["controls","loop","muted","preload","src"];
	var base = ["href","target"];
	var basefont = ["size"];
	var bdo = ["dir"];
	var blockquote = ["cite"];
	var button = ["disabled","form","name","type","value"];
	var canvas = ["height","width"];
	var col = ["span","width"];
	var colgroup = ["span","width"];
	var data = ["value"];
	var del = ["cite"];
	var details = ["open"];
	var dfn = ["title"];
	var dialog = ["open"];
	var embed = ["height","src","type","width"];
	var fieldset = ["disabled","form","name"];
	var font = ["size"];
	var form = ["accept","action","method","name","target"];
	var frame = ["name","scrolling","src"];
	var frameset = ["cols","rows"];
	var head = ["profile"];
	var hr = ["size","width"];
	var html = ["manifest"];
	var iframe = ["height","name","sandbox","scrolling","src","width"];
	var img = ["alt","height","name","sizes","src","width"];
	var input = ["accept","alt","autoCapitalize","autoCorrect","autoSave","checked","defaultChecked","defaultValue","disabled","form","height","list","max","min","multiple","name","onChange","pattern","placeholder","required","results","size","src","step","title","type","value","width"];
	var ins = ["cite"];
	var keygen = ["challenge","disabled","form","name"];
	var label = ["form"];
	var li = ["type","value"];
	var link = ["color","href","integrity","media","nonce","rel","scope","sizes","target","title","type"];
	var map = ["name"];
	var meta = ["content","name"];
	var meter = ["high","low","max","min","optimum","value"];
	var object = ["data","form","height","name","type","width"];
	var ol = ["reversed","start","type"];
	var optgroup = ["disabled","label"];
	var option = ["disabled","label","selected","value"];
	var output = ["form","name"];
	var param = ["name","type","value"];
	var pre = ["width"];
	var progress = ["max","value"];
	var q = ["cite"];
	var script = ["async","defer","integrity","nonce","src","type"];
	var select = ["defaultValue","disabled","form","multiple","name","onChange","required","size","value"];
	var slot = ["name"];
	var source = ["media","sizes","src","type"];
	var style = ["media","nonce","title","type"];
	var table = ["summary","width"];
	var td = ["headers","height","scope","width"];
	var textarea = ["autoCapitalize","autoCorrect","cols","defaultValue","disabled","form","name","onChange","placeholder","required","rows","value","wrap"];
	var th = ["headers","height","scope","width"];
	var track = ["default","kind","label","src"];
	var ul = ["type"];
	var video = ["controls","height","loop","muted","playsInline","poster","preload","src","width"];
	var svg = ["accentHeight","accumulate","additive","alignmentBaseline","allowReorder","alphabetic","amplitude","arabicForm","ascent","attributeName","attributeType","autoReverse","azimuth","baseFrequency","baseProfile","baselineShift","bbox","begin","bias","by","calcMode","capHeight","clip","clipPath","clipPathUnits","clipRule","color","colorInterpolation","colorInterpolationFilters","colorProfile","colorRendering","contentScriptType","contentStyleType","cursor","cx","cy","d","decelerate","descent","diffuseConstant","direction","display","divisor","dominantBaseline","dur","dx","dy","edgeMode","elevation","enableBackground","end","exponent","externalResourcesRequired","fill","fillOpacity","fillRule","filter","filterRes","filterUnits","floodColor","floodOpacity","focusable","fontFamily","fontSize","fontSizeAdjust","fontStretch","fontStyle","fontVariant","fontWeight","format","from","fx","fy","g1","g2","glyphName","glyphOrientationHorizontal","glyphOrientationVertical","glyphRef","gradientTransform","gradientUnits","hanging","height","horizAdvX","horizOriginX","ideographic","imageRendering","in","in2","intercept","k","k1","k2","k3","k4","kernelMatrix","kernelUnitLength","kerning","keyPoints","keySplines","keyTimes","lengthAdjust","letterSpacing","lightingColor","limitingConeAngle","local","markerEnd","markerHeight","markerMid","markerStart","markerUnits","markerWidth","mask","maskContentUnits","maskUnits","mathematical","mode","numOctaves","offset","opacity","operator","order","orient","orientation","origin","overflow","overlinePosition","overlineThickness","paintOrder","panose1","pathLength","patternContentUnits","patternTransform","patternUnits","pointerEvents","points","pointsAtX","pointsAtY","pointsAtZ","preserveAlpha","preserveAspectRatio","primitiveUnits","r","radius","refX","refY","renderingIntent","repeatCount","repeatDur","requiredExtensions","requiredFeatures","restart","result","rotate","rx","ry","scale","seed","shapeRendering","slope","spacing","specularConstant","specularExponent","speed","spreadMethod","startOffset","stdDeviation","stemh","stemv","stitchTiles","stopColor","stopOpacity","strikethroughPosition","strikethroughThickness","string","stroke","strokeDasharray","strokeDashoffset","strokeLinecap","strokeLinejoin","strokeMiterlimit","strokeOpacity","strokeWidth","surfaceScale","systemLanguage","tableValues","targetX","targetY","textAnchor","textDecoration","textLength","textRendering","to","transform","u1","u2","underlinePosition","underlineThickness","unicode","unicodeBidi","unicodeRange","unitsPerEm","vAlphabetic","vHanging","vIdeographic","vMathematical","values","vectorEffect","version","vertAdvY","vertOriginX","vertOriginY","viewBox","viewTarget","visibility","width","widths","wordSpacing","writingMode","x","x1","x2","xChannelSelector","xHeight","xlinkActuate","xlinkArcrole","xlinkHref","xlinkRole","xlinkShow","xlinkTitle","xlinkType","xmlBase","xmlLang","xmlSpace","xmlns","xmlnsXlink","y","y1","y2","yChannelSelector","z","zoomAndPan"];
	var elements = {"html":["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","math","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rb","rp","rt","rtc","ruby","s","samp","script","section","select","slot","small","source","span","strong","style","sub","summary","sup","svg","table","tbody","td","template","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr"],"svg":["a","altGlyph","altGlyphDef","altGlyphItem","animate","animateColor","animateMotion","animateTransform","circle","clipPath","color-profile","cursor","defs","desc","ellipse","feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feDistantLight","feFlood","feFuncA","feFuncB","feFuncG","feFuncR","feGaussianBlur","feImage","feMerge","feMergeNode","feMorphology","feOffset","fePointLight","feSpecularLighting","feSpotLight","feTile","feTurbulence","filter","font","font-face","font-face-format","font-face-name","font-face-src","font-face-uri","foreignObject","g","glyph","glyphRef","hkern","image","line","linearGradient","marker","mask","metadata","missing-glyph","mpath","path","pattern","polygon","polyline","radialGradient","rect","script","set","stop","style","svg","switch","symbol","text","textPath","title","tref","tspan","use","view","vkern"]};
	var reactHtmlAttributes = {
		a: a,
		abbr: abbr,
		applet: applet,
		area: area,
		audio: audio,
		base: base,
		basefont: basefont,
		bdo: bdo,
		blockquote: blockquote,
		button: button,
		canvas: canvas,
		col: col,
		colgroup: colgroup,
		data: data,
		del: del,
		details: details,
		dfn: dfn,
		dialog: dialog,
		embed: embed,
		fieldset: fieldset,
		font: font,
		form: form,
		frame: frame,
		frameset: frameset,
		head: head,
		hr: hr,
		html: html,
		iframe: iframe,
		img: img,
		input: input,
		ins: ins,
		keygen: keygen,
		label: label,
		li: li,
		link: link,
		map: map,
		meta: meta,
		meter: meter,
		object: object,
		ol: ol,
		optgroup: optgroup,
		option: option,
		output: output,
		param: param,
		pre: pre,
		progress: progress,
		q: q,
		script: script,
		select: select,
		slot: slot,
		source: source,
		style: style,
		table: table,
		td: td,
		textarea: textarea,
		th: th,
		track: track,
		ul: ul,
		video: video,
		svg: svg,
		elements: elements,
		"*": ["about","acceptCharset","accessKey","allowFullScreen","allowTransparency","autoComplete","autoFocus","autoPlay","capture","cellPadding","cellSpacing","charSet","classID","className","colSpan","contentEditable","contextMenu","crossOrigin","dangerouslySetInnerHTML","datatype","dateTime","dir","draggable","encType","formAction","formEncType","formMethod","formNoValidate","formTarget","frameBorder","hidden","hrefLang","htmlFor","httpEquiv","icon","id","inlist","inputMode","is","itemID","itemProp","itemRef","itemScope","itemType","keyParams","keyType","lang","marginHeight","marginWidth","maxLength","mediaGroup","minLength","noValidate","prefix","property","radioGroup","readOnly","resource","role","rowSpan","scoped","seamless","security","spellCheck","srcDoc","srcLang","srcSet","style","suppressContentEditableWarning","tabIndex","title","typeof","unselectable","useMap","vocab","wmode"]
	};
	
	var reactHtmlAttributes$1 = Object.freeze({
		a: a,
		abbr: abbr,
		applet: applet,
		area: area,
		audio: audio,
		base: base,
		basefont: basefont,
		bdo: bdo,
		blockquote: blockquote,
		button: button,
		canvas: canvas,
		col: col,
		colgroup: colgroup,
		data: data,
		del: del,
		details: details,
		dfn: dfn,
		dialog: dialog,
		embed: embed,
		fieldset: fieldset,
		font: font,
		form: form,
		frame: frame,
		frameset: frameset,
		head: head,
		hr: hr,
		html: html,
		iframe: iframe,
		img: img,
		input: input,
		ins: ins,
		keygen: keygen,
		label: label,
		li: li,
		link: link,
		map: map,
		meta: meta,
		meter: meter,
		object: object,
		ol: ol,
		optgroup: optgroup,
		option: option,
		output: output,
		param: param,
		pre: pre,
		progress: progress,
		q: q,
		script: script,
		select: select,
		slot: slot,
		source: source,
		style: style,
		table: table,
		td: td,
		textarea: textarea,
		th: th,
		track: track,
		ul: ul,
		video: video,
		svg: svg,
		elements: elements,
		default: reactHtmlAttributes
	});
	
	var reactHtmlAttributes$2 = ( reactHtmlAttributes$1 && reactHtmlAttributes ) || reactHtmlAttributes$1;
	
	var dist = createCommonjsModule(function (module, exports) {
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	exports.default = reactHtmlAttributes$2;
	
	module.exports = reactHtmlAttributes$2; // for CommonJS compatibility
	});
	
	var reactHTMLAttributes = unwrapExports(dist);
	
	/*
	 * This is used to check if a property name is one of the React-specific
	 * properties and determine if that property should be forwarded
	 * to the React component
	 */
	
	/* Logic copied from ReactDOMUnknownPropertyHook */
	var reactProps = ['children', 'dangerouslySetInnerHTML', 'key', 'ref', 'autoFocus', 'defaultValue', 'valueLink', 'defaultChecked', 'checkedLink', 'innerHTML', 'suppressContentEditableWarning', 'onFocusIn', 'onFocusOut', 'className',
	
	/* List copied from https://facebook.github.io/react/docs/events.html */
	'onCopy', 'onCut', 'onPaste', 'onCompositionEnd', 'onCompositionStart', 'onCompositionUpdate', 'onKeyDown', 'onKeyPress', 'onKeyUp', 'onFocus', 'onBlur', 'onChange', 'onInput', 'onInvalid', 'onSubmit', 'onClick', 'onContextMenu', 'onDoubleClick', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'onSelect', 'onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart', 'onScroll', 'onWheel', 'onAbort', 'onCanPlay', 'onCanPlayThrough', 'onDurationChange', 'onEmptied', 'onEncrypted', 'onEnded', 'onError', 'onLoadedData', 'onLoadedMetadata', 'onLoadStart', 'onPause', 'onPlay', 'onPlaying', 'onProgress', 'onRateChange', 'onSeeked', 'onSeeking', 'onStalled', 'onSuspend', 'onTimeUpdate', 'onVolumeChange', 'onWaiting', 'onLoad', 'onAnimationStart', 'onAnimationEnd', 'onAnimationIteration', 'onTransitionEnd', 'onCopyCapture', 'onCutCapture', 'onPasteCapture', 'onCompositionEndCapture', 'onCompositionStartCapture', 'onCompositionUpdateCapture', 'onKeyDownCapture', 'onKeyPressCapture', 'onKeyUpCapture', 'onFocusCapture', 'onBlurCapture', 'onChangeCapture', 'onInputCapture', 'onSubmitCapture', 'onClickCapture', 'onContextMenuCapture', 'onDoubleClickCapture', 'onDragCapture', 'onDragEndCapture', 'onDragEnterCapture', 'onDragExitCapture', 'onDragLeaveCapture', 'onDragOverCapture', 'onDragStartCapture', 'onDropCapture', 'onMouseDownCapture', 'onMouseEnterCapture', 'onMouseLeaveCapture', 'onMouseMoveCapture', 'onMouseOutCapture', 'onMouseOverCapture', 'onMouseUpCapture', 'onSelectCapture', 'onTouchCancelCapture', 'onTouchEndCapture', 'onTouchMoveCapture', 'onTouchStartCapture', 'onScrollCapture', 'onWheelCapture', 'onAbortCapture', 'onCanPlayCapture', 'onCanPlayThroughCapture', 'onDurationChangeCapture', 'onEmptiedCapture', 'onEncryptedCapture', 'onEndedCapture', 'onErrorCapture', 'onLoadedDataCapture', 'onLoadedMetadataCapture', 'onLoadStartCapture', 'onPauseCapture', 'onPlayCapture', 'onPlayingCapture', 'onProgressCapture', 'onRateChangeCapture', 'onSeekedCapture', 'onSeekingCapture', 'onStalledCapture', 'onSuspendCapture', 'onTimeUpdateCapture', 'onVolumeChangeCapture', 'onWaitingCapture', 'onLoadCapture', 'onAnimationStartCapture', 'onAnimationEndCapture', 'onAnimationIterationCapture', 'onTransitionEndCapture'];
	
	if (isPreact) {
	  reactProps.push('autocomplete', 'autofocus', 'class', 'for', 'onDblClick', 'onSearch', 'slot', 'srcset');
	}
	
	/* eslint max-lines:0, func-style:0 */
	
	var globalReactHtmlProps = reactHTMLAttributes['*'];
	var supportedSVGTagNames = reactHTMLAttributes.elements.svg;
	var supportedHtmlTagNames = reactHTMLAttributes.elements.html;
	
	// these are valid attributes that have the
	// same name as CSS properties, and is used
	// for css overrides API
	var cssProps = ['color', 'height', 'width'];
	
	/* From DOMProperty */
	var ATTRIBUTE_NAME_START_CHAR =
	// eslint-disable-next-line max-len
	':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	// eslint-disable-next-line max-len
	var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
	var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
	
	var isSvgTag = function (tagName) {
	  return (
	    // in our context, we only say that SVG tags are SVG
	    // if they are not also HTML.
	    // See https://github.com/paypal/glamorous/issues/245
	    // the svg tag will always be treated as svg for
	    // er... obvious reasons
	    tagName === 'svg' || supportedHtmlTagNames.indexOf(tagName) === -1 && supportedSVGTagNames.indexOf(tagName) !== -1
	  );
	};
	var isHtmlProp = function (name, tagName) {
	  var elementAttributes = void 0;
	
	  if (isSvgTag(tagName)) {
	    // all SVG attributes supported by React are grouped under 'svg'
	    elementAttributes = reactHTMLAttributes.svg;
	  } else {
	    elementAttributes = reactHTMLAttributes[tagName] || [];
	  }
	
	  return globalReactHtmlProps.indexOf(name) !== -1 || elementAttributes.indexOf(name) !== -1;
	};
	var isCssProp = function (name) {
	  return cssProps.indexOf(name) !== -1;
	};
	var isReactProp = function (name) {
	  return reactProps.indexOf(name) !== -1;
	};
	
	// eslint-disable-next-line complexity
	var shouldForwardProperty = function (tagName, name) {
	  return typeof tagName !== 'string' || (isHtmlProp(name, tagName) || isReactProp(name) || isCustomAttribute(name.toLowerCase())) && (!isCssProp(name) || isSvgTag(tagName));
	};
	
	var shouldForwardProperty$1 = src(shouldForwardProperty);
	
	// eslint-disable-next-line complexity
	function splitProps(_ref, _ref2) {
	  var propsAreCssOverrides = _ref2.propsAreCssOverrides,
	      rootEl = _ref2.rootEl,
	      filterProps = _ref2.filterProps,
	      forwardProps = _ref2.forwardProps;
	  var cssProp = _ref.css,
	      innerRef = _ref.innerRef,
	      theme = _ref.theme,
	      className = _ref.className,
	      glam = _ref.glam,
	      rest = objectWithoutProperties(_ref, ['css', 'innerRef', 'theme', 'className', 'glam']);
	
	  // forward innerRef if user wishes to do so
	  if (innerRef !== undefined && forwardProps.indexOf('innerRef') !== -1) {
	    rest.innerRef = innerRef;
	  }
	  var returnValue = { toForward: {}, cssProp: cssProp, cssOverrides: {} };
	  if (!propsAreCssOverrides) {
	    if (typeof rootEl !== 'string' && filterProps.length === 0) {
	      // if it's not a string and filterProps is empty,
	      // then we can forward everything (because it's a component)
	      returnValue.toForward = rest;
	      return returnValue;
	    }
	  }
	  return Object.keys(rest).reduce(function (split, propName) {
	    if (filterProps.indexOf(propName) !== -1) {
	      return split;
	    } else if (forwardProps.indexOf(propName) !== -1 || shouldForwardProperty$1(rootEl, propName)) {
	      split.toForward[propName] = rest[propName];
	    } else if (propsAreCssOverrides) {
	      split.cssOverrides[propName] = rest[propName];
	    }
	    return split;
	  }, returnValue);
	}
	
	var glamorous = createGlamorous(splitProps);
	
	/*
	 * This creates a glamorousComponentFactory for every DOM element so you can
	 * simply do:
	 * const GreenButton = glamorous.button({
	 *   backgroundColor: 'green',
	 *   padding: 20,
	 * })
	 * <GreenButton>Click Me!</GreenButton>
	 */
	Object.assign(glamorous, domElements.reduce(function (getters, tag) {
	  // TODO: next breaking change, let's make
	  // the `displayName` be: `glamorous.${tag}`
	  getters[tag] = glamorous(tag);
	  return getters;
	}, {}));
	
	/*
	 * This creates a glamorous component for each DOM element so you can
	 * simply do:
	 * <glamorous.Div
	 *   color="green"
	 *   marginLeft={20}
	 * >
	 *   I'm green!
	 * </glamorous.Div>
	 */
	Object.assign(glamorous, domElements.reduce(function (comps, tag) {
	  var capitalTag = capitalize(tag);
	  comps[capitalTag] = glamorous[tag]();
	  comps[capitalTag].displayName = 'glamorous.' + capitalTag;
	  comps[capitalTag].propsAreCssOverrides = true;
	  return comps;
	}, {}));
	
	function capitalize(s) {
	  return s.slice(0, 1).toUpperCase() + s.slice(1);
	}
	
	/*
	 * Fix importing in typescript after rollup compilation
	 * https://github.com/rollup/rollup/issues/1156
	 * https://github.com/Microsoft/TypeScript/issues/13017#issuecomment-268657860
	 */
	glamorous.default = glamorous;
	
	
	var glamorousStar = Object.freeze({
		default: glamorous,
		ThemeProvider: ThemeProvider,
		withTheme: withTheme
	});
	
	/* istanbul ignore next */
	
	var glamorous$1 = glamorous;
	
	Object.assign(glamorous$1, Object.keys(glamorousStar).reduce(function (e, prop) {
	  if (prop !== 'default') {
	    // eslint-disable-next-line import/namespace
	    e[prop] = glamorousStar[prop];
	  }
	  return e;
	}, {}));
	
	module.exports = glamorous$1;


/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(142);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(108);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(138);
	
	var _HelmetConstants = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(112));
	var shallowEqual = _interopDefault(__webpack_require__(143));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 143:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/3p_facebookQ.3ec1447b.jpg";

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/brazil_nexus.6f1f8418.jpg";

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAFo9M/3AAABWUlEQVQ4jY1TzVXCQBicSXI3doAVQAfagbEDDtnNUToQKxCPbHhPStAKTAlYgXQgRy/Z8eAmb4GIfLfvzfcz880uEIe1Vn3CLmMMS2rSkHwCyEniKBjQEQBIWicAJj1K3vQDjTEve73GmGtr7VNUcN/TMMZ8kcwPF3rvi6Qsy9shUNI6SZLXWOdDWKMw9f1YxKmIO+OrMcjZkFwccGi899OMZANgfTiR5C5N010n84XkdGBznlprRXIyAG4lfSfOOQKI79BxmdR1/ZwFQpNwrF3btos0TUFyBOBjwNHjqKpq7L2fAShINs65u17MYXFZlreRBXP8Poei4+2cu4rrT5p9RswTAKjr+lLS7NwuSWsAuXPusWNwHY5SRHTPYpBVVTWWVEjqvNr9I2fatm2TZVm+XC73XQg/YgZgEezadptIvkradLlz7hEYcCEadiFpKmm7Wq3e/qr7AW5Jo+beBiDAAAAAAElFTkSuQmCC"

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.8f669f49.svg";

/***/ }),

/***/ 315:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(37);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _glamor = __webpack_require__(24);
	
	var _gatsbyLink = __webpack_require__(72);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _mysettings = __webpack_require__(82);
	
	var _mysettings2 = _interopRequireDefault(_mysettings);
	
	var _typography = __webpack_require__(61);
	
	var _gatsbyImage = __webpack_require__(114);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _flash = __webpack_require__(81);
	
	var _flash2 = _interopRequireDefault(_flash);
	
	var _previewLink = __webpack_require__(231);
	
	var _previewLink2 = _interopRequireDefault(_previewLink);
	
	var _reactHelmet = __webpack_require__(137);
	
	__webpack_require__(315);
	
	var _logo = __webpack_require__(516);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _ico = __webpack_require__(515);
	
	var _ico2 = _interopRequireDefault(_ico);
	
	var _brazil_nexus = __webpack_require__(514);
	
	var _brazil_nexus2 = _interopRequireDefault(_brazil_nexus);
	
	var _p_facebookQ = __webpack_require__(512);
	
	var _p_facebookQ2 = _interopRequireDefault(_p_facebookQ);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//"../img/3p_facebook.jpg";
	
	//import logo from "../img/logo.png";
	var linkStyle = (0, _glamor.css)({ float: "right" });
	//import 'bootstrap/dist/css/bootstrap.min.css';
	
	
	var myAttr = { 'page_id': '457049377675752' };
	
	var contacts = [{ name: "Vadim Pecherskiy", email: "pecher_v%20[at]%20mail.ru" }, { name: "Alena Zyateva", email: "alenka_sunny%20[at]%20list.ru" }];
	
	//const InnerHTML = require('dangerously-set-inner-html')
	//const html = `
	//  <script>
	//     (adsbygoogle = window.adsbygoogle || []).push({
	//          google_ad_client: "ca-pub-2016028305768327",
	//          enable_page_level_ads: true
	//     });
	//</script>
	//`
	
	//import ads from "../layouts/google-ads.js";
	
	exports.default = function (_ref) {
	    var children = _ref.children,
	        data = _ref.data;
	    return Glamor.createElement(
	        _glamorous2.default.Div,
	        {
	            margin: "0 auto",
	            maxWidth: 1600,
	            padding: (0, _typography.rhythm)(2),
	            paddingTop: (0, _typography.rhythm)(1.5),
	            className: "alignCenter"
	        },
	        Glamor.createElement(
	            _reactHelmet.Helmet,
	            null,
	            Glamor.createElement(
	                "title",
	                null,
	                data.site.siteMetadata.title
	            ),
	            Glamor.createElement("link", { rel: "shortcut icon", href: _ico2.default }),
	            Glamor.createElement("script", { async: '', src: (0, _gatsbyLink.withPrefix)('/fbChat.js') })
	        ),
	        Glamor.createElement("div", null),
	        Glamor.createElement(
	            "div",
	            { className: "logoDiv" },
	            Glamor.createElement(
	                _gatsbyLink2.default,
	                { to: "/" },
	                Glamor.createElement(_glamorous2.default.Img, { src: _logo2.default, style: { marginBottom: 0, width: "100%", maxWidth: "600px" }, alt: data.site.siteMetadata.title })
	            )
	        ),
	        children(),
	        Glamor.createElement("br", null),
	        Glamor.createElement(_previewLink2.default, { img: _p_facebookQ2.default, w: "450",
	            to: "http://www.facebook.com/3PandasGame",
	            alt: "3 Pandas facebook", title: "3 Pandas - visit fan page", target: "_blank", text: ""
	        }),
	        Glamor.createElement(
	            "div",
	            null,
	            Glamor.createElement(
	                "span",
	                { style: { paddingRight: "10px" } },
	                "Contact:"
	            ),
	            contacts.map(function (contact, i) {
	                return Glamor.createElement(
	                    "span",
	                    { key: i },
	                    Glamor.createElement(
	                        "a",
	                        { href: "mailto:" + contact.email },
	                        contact.name
	                    ),
	                    i == contacts.length - 1 ? "" : " | "
	                );
	            })
	        ),
	        Glamor.createElement("div", {
	            className: "fb-customerchat",
	            "data-page_id": "457049377675752" /* data- wasn't there, just for react */
	            , "data-ref": "chat",
	            "data-theme_color": "#222222",
	            "data-minimized": "false" }),
	        Glamor.createElement(
	            "div",
	            { style: { marginTop: "20px" } },
	            Glamor.createElement("img", { src: "https://www.easycounter.com/counter.php?sunlight16", alt: "" })
	        )
	    );
	};
	
	var query = exports.query = "** extracted graphql fragment **";
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*export default ({ data }) => {
	  return (
	    <embed src={data.src} quality="high" bgcolor="#ffffff" 
	        width="550" height="185" name="paintlogo" align="middle" allowScriptAccess="sameDomain" allowFullScreen="false" 
	        type="application/x-shockwave-flash" pluginspage="http://www.macromedia.com/go/getflashplayer" />
	      <div>{this.props.src}</div>
	  );
	};*/
	
	var Flash = function (_React$Component) {
	    _inherits(Flash, _React$Component);
	
	    function Flash() {
	        _classCallCheck(this, Flash);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    Flash.prototype.render = function render() {
	        var isPowerful = this.props.wmode == "direct";
	        var wmode = this.props.wmode != "" ? Glamor.createElement("param", { name: "wmode", value: this.props.wmode }) : Glamor.createElement("param", { name: "wmode" });
	        var fullscreen = Glamor.createElement("param", { name: "allowFullScreenInteractive", value: isPowerful });
	        return Glamor.createElement(
	            "object",
	            { width: this.props.w, height: this.props.h, id: "movie_name" },
	            Glamor.createElement("param", { name: "movie", value: this.props.src }),
	            Glamor.createElement("param", { name: "quality", value: "high" }),
	            wmode,
	            fullscreen,
	            Glamor.createElement(
	                "object",
	                { type: "application/x-shockwave-flash", data: this.props.src, width: this.props.w, height: this.props.h },
	                Glamor.createElement("param", { name: "movie", value: this.props.src }),
	                Glamor.createElement("param", { name: "quality", value: "high" }),
	                wmode,
	                fullscreen,
	                Glamor.createElement(
	                    "div",
	                    { style: { fontSize: "175%" } },
	                    Glamor.createElement(
	                        "p",
	                        null,
	                        "You can play the game if you have Flash Player working. "
	                    ),
	                    Glamor.createElement(
	                        "p",
	                        null,
	                        "Or ",
	                        Glamor.createElement(
	                            "a",
	                            { href: "/games/3-pandas" },
	                            "Play 3 Pandas"
	                        ),
	                        " HTML game"
	                    )
	                )
	            )
	        )
	
	        /*<embed src={this.props.src} quality="high" bgcolor="#ffffff" 
	        width={this.props.w} height={this.props.h} name="paintlogo" align="middle" allowScriptAccess="sameDomain" allowFullScreen="false" 
	        type="application/x-shockwave-flash" pluginspage="http://www.macromedia.com/go/getflashplayer" />*/
	        ;
	    };
	
	    return Flash;
	}(_react2.default.Component);
	
	module.exports = Flash;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(37);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _glamor = __webpack_require__(24);
	
	var _gatsbyLink = __webpack_require__(72);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PreviewLink = function (_React$Component) {
	  _inherits(PreviewLink, _React$Component);
	
	  function PreviewLink() {
	    _classCallCheck(this, PreviewLink);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PreviewLink.prototype.render = function render() {
	    return Glamor.createElement(
	      "a",
	      { href: this.props.to, className: "previewLink", target: this.props.target },
	      Glamor.createElement(_glamorous2.default.Img, { src: this.props.img, style: { marginBottom: 0, width: this.props.w }, alt: this.props.alt }),
	      Glamor.createElement("br", null),
	      Glamor.createElement(
	        _glamorous2.default.Span,
	        { color: "#666", className: "genre" },
	        this.props.title
	      ),
	      Glamor.createElement("br", null),
	      this.props.text,
	      Glamor.createElement("br", null)
	    );
	  };
	
	  return PreviewLink;
	}(_react2.default.Component);
	
	module.exports = PreviewLink;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),

/***/ 82:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = {
	  img_folder: "/static/"
	  //      "http://flashteam.ru/images/"; 
	};
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-daa889a7136f85f29a4e.js